import API from "@/services/api/api.service";
import { RouteLocationNormalized } from "vue-router";

export const contentCategoryResolver = async (to: RouteLocationNormalized, from: RouteLocationNormalized) => {
    try {
        const res = await API.getContentCategory(to.params.id as string);
        to.meta.category = res.data.data;
    } catch(error) {
        console.error('CONTENT_CATEGORY_RESOLVER_ERROR');
        return { name: 'ContentCategories' };
    }
}